<template>
    <div class="row justify-center">
        <template v-if="activeCustomer.firstname">
            <q-list v-if="show" class="col-12 bg-white">
                <q-expansion-item
                    dense
                    group="somegroup"
                    :label="`Your cart (${inStockList.length})`"
                    default-opened
                    header-class="text-primary"
                >
                    <div>
                        <CartItem
                            class="q-mt-sm q-mb-md"
                            style="padding: 0px 10px"
                            v-for="item in inStockList"
                            :key="item.cprcode"
                            :info="item"
                            :disable="false"
                        />
                    </div>
                </q-expansion-item>

                <q-separator />

                <q-expansion-item
                    dense
                    v-if="overStockList.length > 0"
                    group="somegroup"
                    :label="`Not enough stock (${overStockList.length})`"
                    header-class="text-primary"
                >
                    <div>
                        <CartItem
                            class="q-mt-sm q-mb-md"
                            style="padding: 0px 10px"
                            v-for="item in overStockList"
                            :key="item.cprcode"
                            :info="item"
                            :disable="false"
                        />
                    </div>
                </q-expansion-item>

                <q-separator />

                <q-expansion-item
                    dense
                    v-if="outOfStockList.length > 0"
                    group="somegroup"
                    :label="`Out of stock (${outOfStockList.length})`"
                    header-class="text-primary"
                >
                    <div>
                        <CartItem
                            class="q-mt-sm q-mb-md"
                            style="padding: 0px 10px"
                            v-for="item in outOfStockList"
                            :key="item.cprcode"
                            :info="item"
                            :disable="false"
                        />
                    </div>
                </q-expansion-item>

                <q-separator />

                <q-expansion-item
                    dense
                    v-if="unavailableList.length > 0"
                    group="somegroup"
                    :label="`Unavailable (${unavailableList.length})`"
                    header-class="text-primary"
                >
                    <div>
                        <CartItem
                            class="q-mt-sm q-mb-md"
                            style="padding: 0px 10px"
                            v-for="item in unavailableList"
                            :key="item.cprcode"
                            :info="item"
                            :disable="false"
                        />
                    </div>
                </q-expansion-item>
            </q-list>
        </template>

        <template v-else>
            <div class="q-ma-lg text-h6">Please choose customer.</div>
        </template>
    </div>
</template>

<script>
import DialogAlert from "@/ui/components/DialogAlert";
import { mapState } from "vuex";
export default {
    name: "Cart",
    components: {
        DialogAlert,
        TitleBar: () => import(`@/ui/components/TitleBar`),
        TileBar: () => import(`@/ui/components/TileBar`),
        CartItem: () => import(`@/ui/pages/Cart/CartItem.vue`),
        SuggestProductGroup: () =>
            import(`@/ui/pages/Cart/SuggestProductGroup`),
    },
    data() {
        return {};
    },
    computed: {
        ...mapState({
            activeCustomer: (state) => state["activeCustomer"]["customer"],
            inStockList: (state) => state["cartData"]["inStockList"],
            outOfStockList: (state) => state["cartData"]["outOfStockList"],
            overStockList: (state) => state["cartData"]["overStockList"],
            unavailableList: (state) => state["cartData"]["unavailableList"],
            loading: (state) => state["cartData"]["loading"],
            catalogLoading: (state) => state["catalog"]["loading"],
        }),
        show() {
            return !this.catalogLoading;
        },
        branchCode() {
            return parseInt(this.$store.state["branch"]["branch"].code);
        },
    },
    watch: {
        catalogLoading: {
            handler: async function (value) {
                if (!value) {
                    this.computeCartData();
                }
            },
        },
    },
    mounted() {
        this.computeCartData();
    },
    methods: {
        async computeCartData() {
            const basket = this.$store.state["cart"]["basket"];
            if (basket) {
                if (basket["productList"]) {
                    await this.$store.dispatch(
                        "cartData/computeCartData",
                        {
                            productList: basket["productList"],
                            changeBasket: false,
                        }
                    );
                    await this.$store.dispatch("cartData/getCost");
                }
            }
        },
        onClear() {
            this.dialog = true;
            this.dialogFrom = "onRemove";
            this.message = "Do you want to clear your cart ?";
        },
        onCancel() {
            this.dialog = false;
        },
        onAddItems() {
            this.$router.push("/portal");
        },
        onChangeSelectAll(val) {
            console.log("onChangeSelectAll to ", val);
            this.$store.commit("cartData/setSelectAll", val);
        },
        async onCheckout() {
            this.$router.push("/portal/checkout");
        },
    },
};
</script>

<style scoped>
.sticky-bottom {
    position: fixed;
    bottom: 0px;
    /* left: 0px; */
    /* right: 0px; */
    background-color: #ffffff;
    -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.3);
    padding: 16px;
    flex-direction: column-reverse;
    display: flex;
}
.title {
    font-size: 18px;
    font: bold;
}
</style>
